import { red } from '@mui/material/colors';

const defaultTheme = {
  palette: {
    primary: {
      light: '#FFA733',
      main: '#FF8A00',
      dark: '#CC6E00',
      contrastText: '#FFF',
      white: '#FFF',
    },
    secondary: {
      light: red[300],
      main: red[500],
      dark: red[700],
      contrastText: '#FFF',
      white: '#FFF',
    },
    grey: {
      1000: '#1D1D1D',
    },
  },
};

export { defaultTheme };
